import { motion } from "framer-motion";
import { Quote } from "lucide-react";
import { recommendations } from "@/data/portfolio";
import { Section } from "@/components/Section";

export const Recommendations = () => (
  <Section id="recommendations" index="04" title="Recommendations">
    <div className="grid gap-8 md:grid-cols-2">
      {recommendations.map((r, i) => (
        <motion.blockquote
          key={r.author}
          data-testid={`recommendation-${r.author.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-40px" }}
          transition={{ duration: 0.6, delay: i * 0.08 }}
          className={`relative border border-white/10 bg-[#0A0A0A] p-8 md:p-10 ${i % 2 === 1 ? "md:mt-14" : ""}`}
        >
          <Quote className="absolute -top-3 left-8 h-6 w-6 bg-[#0A0A0A] text-cyan-400" />
          <p className="text-sm leading-relaxed text-zinc-300 md:text-base">“{r.quote}”</p>
          <footer className="mt-8 border-t border-white/10 pt-5">
            <p className="font-display text-base font-bold text-white">{r.author}</p>
            <p className="mt-1 font-mono text-[11px] uppercase tracking-wider text-cyan-400/80">{r.role}</p>
            <p className="mt-1 font-mono text-[11px] text-zinc-600">
              {r.relationship ? `${r.relationship} · ` : ""}{r.date}
            </p>
          </footer>
        </motion.blockquote>
      ))}
    </div>
  </Section>
);
